import { createAsyncThunk } from "@reduxjs/toolkit";
import feesService from "src/services/feesDetails/fees.service";

export const getFessDetailsById = createAsyncThunk(
  "fees/getFeesDetailsById",
  async (id: number) => {
    return feesService.getFessDetailsById(id);
  }
);
